export function waitForMilliseconds(milliseconds) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, milliseconds);
  });
}

export function waitForNextPaint() {
  return new Promise((resolve) => {
    if (typeof window === 'undefined' || typeof window.requestAnimationFrame !== 'function') {
      resolve();
      return;
    }

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(resolve);
    });
  });
}

export function createLocalId() {
  return typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `item-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function createMediaItem(index, mediaFile) {
  return {
    id: `${createLocalId()}-${index + 1}`,
    mediaFile,
    mediaStoredFileName: mediaFile?.name ?? '',
    transcriptEnabled: false,
    transcriptFile: null,
    transcriptStoredFileName: '',
    mediaUploadStatus: 'idle',
    scanStatus: 'pending',
    transcriptUploadStatus: 'not-applicable',
    transcriptScanStatus: 'idle',
    mediaId: '',
    transcriptFileId: '',
    mediaMetadata: null,
    uploadComplete: false,
    progress: 0,
    description: '',
    transcriptDescription: '',
    latestError: ''
  };
}
